module.exports = __webpack_public_path__ + "static/media/G6.0ce92034.png";